import React from 'react'
import { CYCLES_TYPE } from "../config/settings/constant";
import routes from "../config/settings/routes";
import { usePathParam } from "../modules/hooks/route";
import ProtectBySession from "../components/Security/ProtectBySession";
import BrandLayout from "../components/Layouts/BrandLayout";
import { ExamMode } from '@carbon/icons-react'
import { Breadcrumb, BreadcrumbItem } from '@carbon/react'
import Navbar from "../containers/Navbar/Navbar.container";
import ManagementMenu from "../containers/ManagementMenu/ManagementMenu.container";
import Heading from "../components/Layouts/Heading";
import CycleContainer from '../containers/Cycles/Cycles/Cycles.container';

import AccessControl from '../components/Security/ProtectByGroup';


/**
 * The Records page.
 */
const CyclesPage = () => {
    const type = usePathParam('type').toUpperCase();

    const TypeTitle = type => {
        switch (type) {
            case CYCLES_TYPE.CYCLES:
                return 'Ciclos'
        }
    };

    const getTooltipContent = type => {
        switch (type) {
            case CYCLES_TYPE.CYCLES:
                return 'Consulte ciclos realizados por equipos en turnos pasados.'
        }
    };

    const CycleBreadcrumbs = () => {
        return (
            <Breadcrumb noTrailingSlash>
                <BreadcrumbItem>
                    <a href="/">Salar</a>
                </BreadcrumbItem>
                {CYCLES_TYPE[type] !== CYCLES_TYPE['CYCLES-INITIAL'] && <BreadcrumbItem isCurrentPage>{TypeTitle(type)}</BreadcrumbItem>}
            </Breadcrumb>
        )
    }

    const typeToComponentMap = {
        [CYCLES_TYPE.CYCLES]: CycleContainer
    }
    const ComponentToRender = typeToComponentMap[type];

    return (
        <ProtectBySession rule={(hasSession, signedIn) => !!(hasSession && signedIn)}>
            <BrandLayout
                navbar={<Navbar managementMenu={<ManagementMenu current={routes.cycles} />} />}
                header={<Heading title={TypeTitle(type)} icon={<ExamMode size={50} />} breadcrumbs={<CycleBreadcrumbs />} tooltipContent={getTooltipContent(type)} />}
            >
                <AccessControl type={type}>
                    {ComponentToRender ? <ComponentToRender /> : <div>Component not found</div>}
                </AccessControl>
            </BrandLayout>
        </ProtectBySession>
    )
}

export default CyclesPage